<template>
    <account-menu v-if="authToken" :menuOpen="open"></account-menu>
</template>

<script>
    import AccountMenu from '../account/menu.vue';
    import {mapGetters} from 'vuex';

    export default{
        components: {
            AccountMenu
        },
        computed: {
            ...mapGetters({
                open: 'menu/menuOpen',
                authToken: 'auth/getAuthToken'
            })
        },
        methods: {
            toggleMenu(){
                this.$store.commit({
                    type: 'menu/toggleMenu'
                })
            }
        }
    }
</script>